import ContactForm from "../../components/ContactForm";
import InputMaterial from "../../components/material/Input";
import TextareaMaterial from "../../components/material/Textarea";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";
import { useState } from "react";

import Image from "next/image";

export default function Kontakt(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "kontakt";

	const [telephone, setTelephone] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [rodo, setRodo] = useState(false);
	const [response, setResponse] = useState("");
	const [submitted, setSubmitted] = useState(false);

	const handleCheckbox = (e) => {
		const checked = e.target.checked;
		if (checked) {
			setRodo(true);
		} else {
			setRodo(false);
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (email == "" || message == "" || rodo == false) {
			setResponse(false);
		} else {
			let data = {
				telephone,
				email,
				message,
			};

			fetch("/api/contact/przyjaznedeklaracje", {
				method: "POST",
				headers: {
					Accept: "application/json, text/plain, */*",
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			}).then((res) => {
				setResponse(true);
				if (res.status === 200) {
					setSubmitted(true);
					setTelephone("");
					setEmail("");
					setMessage("");
					setRodo(false);
				}
			});
		}
	};

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			{/* <Section center mdx>
        <PrzyjazneDeklaracjeKontaktPL />
      </Section> */}

			<Section>
				<div className="pd-contact">
					<div className="pd-contact__top">
						<h2 className="pd-contact__title">
							Masz problem techniczny lub pojawił się nieoczekiwany błąd?
						</h2>
						<p>
							Skontaktuj się, aby uzyskać pomoc. Nasi konsultanci są do dyspozycji od poniedziałku
							do piątku w godzinach 7:00-15:00.
						</p>
						<div className="pd-contact__info main">
							<Image
								unoptimized
								src="https://przyjazne-deklaracje.pl/resources/images/icons/general/contact/icon-email.svg"
								alt=""
								width={37}
								height={26}
								style={{
									maxWidth: "100%",
									height: "auto",
								}}
							/>
							<a href="mailto:pomoc@przyjazne-deklaracje.pl">pomoc@przyjazne-deklaracje.pl</a>
						</div>
						<div className="pd-contact__info main">
							<Image
								unoptimized
								src="https://przyjazne-deklaracje.pl/resources/images/icons/general/contact/icon-phone-call.svg"
								alt=""
								width={26}
								height={26}
								style={{
									maxWidth: "100%",
									height: "auto",
								}}
							/>
							<a href="tel:+48530607002">+48 530 607 002</a>
						</div>
						<hr />
						<p>
							<span className="text-bold">Uwaga!</span> W innych sprawach takich jak wysokość stawek
							podatkowych, numery kont itp. kontaktuj się bezpośrednio z Twoim Urzędem.
						</p>
					</div>

					<div className="pd-contact__bottom">
						<div className="pd-contact__bottom__left">
							<h2 className="pd-contact__title">Kontakt dla samorządów, miast i gmin</h2>
							<p>Dariusz Pietrzak</p>
							<div className="pd-contact__info individual">
								<Image
									unoptimized
									src="https://przyjazne-deklaracje.pl/resources/images/icons/general/contact/icon-contact.svg"
									alt=""
									width={60}
									height={60}
									style={{
										maxWidth: "100%",
										height: "auto",
									}}
								/>
								<div className="pd-contact__info__data">
									<span>&nbsp;</span>
									<a href="tel:+48533350708">+48 533 350 708</a>
									<a href="mailto:dpietrzak@przyjazne-deklaracje.pl">
										dpietrzak@przyjazne-deklaracje.pl
									</a>
								</div>
							</div>
						</div>

						<div className="pd-contact__bottom__right">
							<h2 className="pd-contact__title">Biuro</h2>
							<p>O4B Sp. z o.o.</p>
							<div className="pd-contact__info individual">
								<Image
									unoptimized
									src="https://przyjazne-deklaracje.pl/resources/images/icons/general/contact/icon-address.svg"
									alt=""
									width={36}
									height={60}
									style={{
										maxWidth: "100%",
										height: "auto",
									}}
								/>
								<div className="pd-contact__info__data">
									<span>Graniczna 4/9, 20-010 Lublin</span>
									<a href="tel:+48533350709">+48 533 350 709</a>
									<a href="mailto:biuro@o4b.pl">biuro@o4b.pl</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Section>

			{/* <Section lightdark title="sections.kontakt.title">
        <ContactForm
          onClick={(e) => {
            handleSubmit(e)
          }}
          onCheckbox={(e) => {
            handleCheckbox(e)
          }}
          responsePositive={response}>
          <legend className="sr-only">Dane kontaktowe:</legend>
          <div className="pd-contact-form__input">
            <InputMaterial
              name="adres_email"
              type="email"
              required
              value={email}
              placeholder="Twój adres e-mail"
              onChange={(e) => {
                setEmail(e.target.value)
              }}>
              Twój adres e-mail
            </InputMaterial>
          </div>

          <div className="pd-contact-form__input">
            <InputMaterial
              name="numer_telefonu"
              type="tel"
              value={telephone}
              placeholder="Numer telefonu"
              onChange={(e) => {
                setTelephone(e.target.value)
              }}>
              Numer telefonu
            </InputMaterial>
          </div>

          <div className="pd-contact-form__input">
            <TextareaMaterial
              name="tresc_wiadomosci"
              rows="5"
              required
              value={message}
              placeholder="Treść wiadomości"
              onChange={(e) => {
                setMessage(e.target.value)
              }}>
              Treść wiadomości
            </TextareaMaterial>
          </div>
        </ContactForm>
      </Section> */}
		</SectionLayout>
	);
}
